
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eGateinstall",
      function () {
        return require("private-next-pages/eGateinstall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eGateinstall"])
      });
    }
  